module.exports = __webpack_public_path__ + "static/media/icons8-gmail.e20767db.svg";